module.exports = __webpack_public_path__ + "img/RegCat-member.1bf4d278.svg";